import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ResetPasswordPage() {
  return <Navigate to="/member/forgot-password" replace />;
}